export default __webpack_public_path__ + "static/media/icon_inform.104b8705.svg";